import React from 'react';
import { Field } from 'redux-form';
import { required, noopValidate } from 'app/util/validators';
import { renderInputBase } from 'app/components/FormFields/_renderInputBase';
import { mapAutoCompleteName } from 'app/util/autocomplete';
import { toNormalizedBusinessName } from 'app/util/normalizers';

export const BusinessName = ({ ...props }) => {
  const { name, isOptional } = props;
  /* If the question isOptional, replace the required validator */
  const isRequired =  isOptional ? noopValidate : required;
  return (
    <Field
      autoComplete       = {mapAutoCompleteName(name)}
      component          = {renderInputBase}
      customProps        = {props.customProps}
      fieldPopover       = {props.fieldPopover}
      formControlClasses = {props.formControlClasses}
      inputClasses       = {props.inputClasses}
      inputGridProps     = {props.inputGridProps}
      normalize          = {toNormalizedBusinessName}
      label              = {props.label}
      maxLength          = {100}
      name               = {name}
      popover            = {props.popover}
      type               = 'text'
      validate           = {[isRequired]}
    />
  );
};
